import { memo } from 'react'
import './styles.css'
import iconSort from '../../assets/icons/sort.svg'
import iconSortAlpha from '../../assets/icons/sort-alpha-down.svg'

const Table = memo(function Table({ columns = [], data = [], onSort, sortedColumn, sortOrder, onRowClick }) {
  return (
    <div className="table-container">
      <table className="table">
        <thead className="table-header">
          <tr>
            {columns.map((column) => {
              const isActive = sortedColumn === column.key
              return (
                <th key={column.key} className="table-header-cell" style={column.minWidth ? { minWidth: column.minWidth } : {}}>
                  <div className="table-header-content">
                    <span>{column.label}</span>
                    {column.sortable && (
                      <button
                        className={`table-sort-button ${isActive ? 'table-sort-button-active' : ''}`}
                        onClick={() => onSort && onSort(column.key)}
                        title={isActive ? (sortOrder === 'asc' ? 'Ascendente' : 'Descendente') : 'Ordenar'}
                      >
                        {isActive ? (
                          <span style={{ fontSize: '11px', lineHeight: 1, color: 'var(--dk-green-700)', fontWeight: 700 }}>
                            {sortOrder === 'asc' ? '↑' : '↓'}
                          </span>
                        ) : (
                          <img src={column.sortType === 'alpha' ? iconSortAlpha : iconSort} alt="Sort" className="sort-icon" />
                        )}
                      </button>
                    )}
                  </div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody className="table-body">
          {data.map((row, index) => (
            <tr
              key={index}
              className={`table-row ${onRowClick ? 'table-row-clickable' : ''}`}
              onClick={() => onRowClick && onRowClick(row)}
            >
              {columns.map((column) => (
                <td key={column.key} className="table-cell" style={column.minWidth ? { minWidth: column.minWidth } : {}}>
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
})

export default Table
